import { Icon } from '@chakra-ui/react';

interface Props {
  exclamationColor: string;
  [key: string]: any;
}

export const ExclamationCircleIcon: React.FC<Props> = ({
  exclamationColor = 'white',
  ...props
}) => (
  <Icon viewBox="0 0 16 16" data-testid="exclamation-icon" {...props}>
    <g fill="none" fillRule="evenodd">
      <rect width="16" height="16" rx="8" fill="currentColor" />
      <path
        d="M8.614 9.107c.068-.341.123-.676.164-1.004a7.87 7.87 0 0 0 .063-.992V4H7.193v3.11c0 .334.021.665.063.993.041.328.096.663.164 1.004h1.194ZM8 12a1.03 1.03 0 0 0 .71-.266.893.893 0 0 0 .29-.664.87.87 0 0 0-.29-.658A1.044 1.044 0 0 0 8 10.14c-.144 0-.277.025-.398.073a1.008 1.008 0 0 0-.315.199.92.92 0 0 0-.21.294.87.87 0 0 0-.077.364.912.912 0 0 0 .287.663.97.97 0 0 0 .315.196c.121.047.254.071.398.071Z"
        fill={exclamationColor}
        fillRule="nonzero"
      />
    </g>
  </Icon>
);
